import React, { useState, useEffect, useRef } from 'react';
import { FiMenu, FiX, FiChevronDown } from 'react-icons/fi';
import './Header.css';
import { Tag } from 'antd';
import Services from '../../components/HeaderBar/Services';
import { Box, Fab, useScrollTrigger, Zoom } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const HeaderBar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    const handleClickOutside = (event) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(event.target)) {
        // Check if the click is not on the menu button
        const menuButton = document.querySelector('.mobile-menu-button');
        if (menuButton && !menuButton.contains(event.target)) {
          setIsMenuOpen(false);
        }
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    // Add a small delay to allow the click event to complete
    setTimeout(() => {
      setIsMenuOpen(prev => !prev);
    }, 100);
  };

  function ScrollTop(props) {
    const { children } = props;
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 100,
    });

    const handleClick = (event) => {
      const anchor = (event.target.ownerDocument || document).querySelector(
        '#back-to-top-anchor',
      );
      if (anchor) {
        anchor.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    };

    return (
      <Zoom in={trigger}>
        <Box
          onClick={handleClick}
          role="presentation"
          sx={{ position: 'fixed', bottom: 32, right: 32 }}
        >
          {children}
        </Box>
      </Zoom>
    );
  }

  return (
    <>
      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-container">
          <div className="logo-container">
            <a onClick={()=> navigate('/')} className="logo">
              <span className="logo-tech">Shreesh</span>
              <span className="logo-ai">Tech</span>
            </a>
          </div>

          <button className="mobile-menu-button" onClick={toggleMenu}>
            {isMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>

          <nav className={`desktop-menu ${isMobile ? 'mobile-hidden' : ''}`}>
            <ul>
              <li className="dropdown" style={{ position: "relative" }}>
                <a onClick={()=>navigate('/services')}>
                  Services <FiChevronDown className="dropdown-icon" />
                </a>
                <div
                  className="dropdown-content"
                  style={{
                    width: "600px",
                    position: "absolute",
                    left: 0,
                    padding: "20px",
                    background: "#fff",
                    boxShadow: "0 4px 8px rgb(244, 240, 240)",
                  }}
                >
                  <Services />
                </div>
              </li>
              <li><a onClick={()=>navigate('/case-studies')}>Case Studies</a></li>
              <li><a onClick={()=>navigate('/about-us')}>About us</a></li>
              <li>
                <a onClick={()=>navigate('/get-in-touch')}>
                  <Tag color="magenta" style={{ fontSize: '16px', padding: '4px 10px' }}>Get in Touch</Tag>
                </a>
              </li>
            </ul>
          </nav>

          <div 
            ref={menuRef}
            className={`mobile-menu ${isMenuOpen && isMobile ? 'open' : ''}`}
            onClick={(e) => {
              // Close menu when clicking on a link
              if (e.target.tagName === 'A') {
                setTimeout(() => setIsMenuOpen(false), 300);
              }
            }}
          >
            <nav>
              <ul>
                <li className="mobile-dropdown">
                  <a onClick={() => navigate('/services')}>
                    Services
                  </a>
                </li>
                <li><a onClick={() => navigate('/case-studies')}>Case Studies</a></li>
                <li><a onClick={() => navigate('/about-us')}>About us</a></li>
                <li><a onClick={() => navigate('/internship')}>Internship</a></li>
                <li>
                  <a onClick={() => navigate('/get-in-touch')}>
                    <Tag
                      color="magenta"
                      style={{
                        fontSize: '16px',
                        padding: '4px 10px',
                        animation: 'glow 1.5s infinite ease-in-out',
                        boxShadow: '0 0 5px #eb2f96, 0 0 10px #eb2f96, 0 0 20px #eb2f96',
                      }}
                    >
                      Get in Touch
                    </Tag>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderBar;